import { render } from "./LocaleSwitcher.vue?vue&type=template&id=5826802b&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=5826802b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Devices_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5826802b"]])

export default __exports__